/* eslint-disable prettier/prettier */
import { Navigate, useSearchParams } from "react-router-dom";
import { NewPasswordForm } from "../components/Auth/NewPasswordForm";
import { Card } from "../components/Shared/Card";
import Footer from "../components/Shared/Footer";
import { Content } from "../components/ui/ContentArea";

export function ResetPasswordPage() {
	const [searchParams] = useSearchParams();
	const token = searchParams.get("token");

	if (token == null || token.trim() === "") {
		return <Navigate to="/login" replace />;
	}

	return (
		<Content>
			<div className="flex flex-col items-center justify-center flex-1">
				<h1 className="grid grid-cols-2 gap-10">
					<img src="/img/Logo_Cluster_Completo.svg" className="h-30" />
					<img src="/img/Logo_Wunder_Completo.svg" className="h-30" />
				</h1>

				<Card style={{ minWidth: "450px", margin: "16pt" }}>
					<NewPasswordForm token={token} />
				</Card>
			</div>

			<Footer />
		</Content>
	);
}